import React, { useRef, useCallback } from 'react';
import Slider, { Settings } from 'react-slick';
import photo1 from 'assets/images/gallery-05/1.jpg';
import photo2 from 'assets/images/gallery-05/2.jpg';
import photo3 from 'assets/images/gallery-05/3.jpg';
import photo4 from 'assets/images/gallery-05/4.jpg';
import photo5 from 'assets/images/gallery-05/5.jpg';
import photo6 from 'assets/images/gallery-05/6.jpg';

import * as S from './styles';

const Gallery05: React.FC = () => {
  const slideBeautyRef = useRef<Slider>(null);
  const sliderSettings: Settings = {
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 501,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  type Directions = 'next' | 'prev';
  const handleNavigation = useCallback((direction: Directions) => {
    if (slideBeautyRef.current) {
      if (direction === 'next') {
        slideBeautyRef.current.slickNext();
      }
      if (direction === 'prev') {
        slideBeautyRef.current.slickPrev();
      }
    }
  }, []);
  return (
    <S.Container
      className="wow animate__animated animate__zoomIn"
      data-wow-duration="1s"
    >
      <S.Button className="left" onClick={() => handleNavigation('prev')}>
        <S.ArrowLeftIcon />
      </S.Button>
      <S.Button className="right" onClick={() => handleNavigation('next')}>
        <S.ArrowRightIcon />
      </S.Button>
      <Slider ref={slideBeautyRef} {...sliderSettings}>
        <S.ImageWrapper>
          <img
            src={photo1}
            alt="Cena do filme Natural Born Killers | Foto: Reprodução"
          />
          <S.CaptionPhoto>
            Cena do filme Natural Born Killers | Foto: Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
        <S.ImageWrapper>
          <img src={photo2} alt="Cena do filme Querelle | Foto: Reprodução" />
          <S.CaptionPhoto>
            Cena do filme Querelle | Foto: Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
        <S.ImageWrapper>
          <img
            src={photo3}
            alt="Cena do vídeo clipe de Telephone, de Lady Gaga com Beyoncé | Foto: Reprodução"
          />
          <S.CaptionPhoto>
            Cena do vídeo clipe de Telephone, de Lady Gaga com Beyoncé | Foto:
            Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
        <S.ImageWrapper>
          <img
            src={photo4}
            alt="Cena da série The Handmaid's Tale | Foto: Reprodução"
          />
          <S.CaptionPhoto>
            Cena da série The Handmaid's Tale | Foto: Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
        <S.ImageWrapper>
          <img
            src={photo5}
            alt="Cena do filme  Wild at Heart | Foto: Reprodução"
          />
          <S.CaptionPhoto>
            Cena do filme Wild at Heart | Foto: Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
        <S.ImageWrapper>
          <img src={photo6} alt="Cena do filme  Dogville | Foto: Reprodução" />
          <S.CaptionPhoto>
            Cena do filme Dogville | Foto: Reprodução
          </S.CaptionPhoto>
        </S.ImageWrapper>
      </Slider>
    </S.Container>
  );
};

export default Gallery05;
